<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <template slot="choose_info">
            <selectCom :tabList="tabList" @getTab="getTab"></selectCom>
        </template>
        <div class="widget_cont">
            <div class="res_right">
                <div class="class_type" v-if="widgetType != 1">
                    <div class="class_list" @click="nodeSplicing({
                                node:'myCreateCesource',
                                param:{index:1},
                                breadcrumb:'个人中心'
                            })">
                        <div>{{tableData.myCreateCesource.number || 0}}</div>
                        <div>我上传的</div>
                    </div>
                    <div class="class_list" @click="nodeSplicing({
                                                    node:'myCollection',
                                                    param:{index:3},
                                                    breadcrumb:'个人中心'
                                                })">
                        <div>{{tableData.myCollection.number || 0}}</div>
                        <div>我的收藏</div>
                    </div>
                    <div class="class_list" @click="nodeSplicing({
                                                    node:'downloadCount',
                                                    param:{index:2},
                                                    breadcrumb:'个人中心'
                                                })">
                        <div>{{tableData.downloadCount.number || 0}}</div>
                        <div>已下载</div>
                    </div>
                    <div class="class_list" @click="nodeSplicing({
                                                    node:'myCredit',
                                                    param:{index:4},
                                                    breadcrumb:'个人中心'
                                                })">
                        <div>{{tableData.myCredit.number || 0}}</div>
                        <div>我的积分</div>
                    </div>
                </div>
                <div class="down_cont" v-if="widgetType == 3">
                    <div class="down_title">下载排行</div>
                    <div class="down_main">
                        <div class="down_list" v-for="(down,index) in tableData.downloadingRankings" :key="index">
                            <span class="ico fa fa-bookmark"><span>{{index+1}}</span></span>
                            <div class="title" @click="nodeSplicing({
                                                                    node:'downloadingRankings,resourceTitle',
                                                                    param:down,
                                                                    breadcrumb:'资源详情'
                                                                })">{{down.resourceTitle}}</div>
                            <div class="down_about">{{down.resourceCreationTime | dateFilter}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="res_left">
                <template v-if="activeName == '最新'">
                    <div v-for="(list,index) in tableData.newResources" class="res_list" :key="index">
                        <img src="../img/format/packge2.png" v-if="list.typeNum == '0'" >
                        <img src="../img/format/questions.png" v-if="list.typeNum == '5'" >
                        <img src="../img/format/task.png" v-else-if="list.typeNum == '7'">
                        <img src="../img/format/teachingBag.png" v-else-if="list.typeNum == '8'">
                        <img src="../img/format/test_paper2.png" v-else-if="list.typeNum == '10'">
                        <img :src="imgUrl+list.resouceDownloadId" v-else @error="errorImg($event,'image')">
                        <div class="title"  @click="nodeSplicing({
                                                                    node:'newResources,resourceTitle',
                                                                    param:list,
                                                                    breadcrumb:'资源详情'
                                                                })">{{list.resourceTitle}}</div>
                        <div class="list_about">
                            <span class="user">{{list.resourceCreator}}</span>
                            <span>{{list.resourceCreationTime | dateFilter}}</span>
                            <span>上传</span>
                            <span class="list_bar">
                                <i class="el-icon-star-on" v-if="list.collection == 1"></i>
                                <i class="el-icon-star-off" @click="collection(list)" v-else></i>
                                <i class="el-icon-download" @click="nodeSplicing({
                                                                                    node:'newResources,resourceDownloadId',
                                                                                    param:list
                                                                                })" v-if="list.typeCode == 7 || list.typeCode == 10 || list.typeCode == 5 || list.typeCode == 8"></i>
                            </span>
                        </div>
                    </div>
                </template>
                <template v-if="activeName == '热门'">
                    <div v-for="(list,index) in tableData.hotResources" class="res_list" :key="index">
                        <img src="../img/format/packge2.png" v-if="list.typeNum == '0'" >
                        <img src="../img/format/questions.png" v-else-if="list.typeNum == '5'" >
                        <img src="../img/format/task.png" v-else-if="list.typeNum == '7'">
                        <img src="../img/format/teachingBag.png" v-else-if="list.typeNum == '8'">
                        <img src="../img/format/test_paper2.png" v-else-if="list.typeNum == '10'">
                        <img :src="imgUrl+list.downLoadIds" v-else @error="errorImg($event,'image')">
                        <div class="title"  @click="nodeSplicing({
                                                                    node:'hotResources,resourceTitle',
                                                                    param:list,
                                                                    breadcrumb:'资源详情'
                                                                })">{{list.resourceTitle}}</div>
                        <div class="list_about">
                            <span class="user">{{list.resourceCreator}}</span>
                            <span>{{list.resourceCreationTime | dateFilter}}</span>
                            <span>上传</span>
                            <span class="list_bar">
                                <i class="el-icon-star-on" v-if="list.collection == 1"></i>
                                <i class="el-icon-star-off" @click="collection(list)" v-else></i>
                                <i class="el-icon-download" @click="nodeSplicing({
                                                                                    node:'hotResources,resourceDownloadId',
                                                                                    param:list
                                                                                })" v-if="list.typeCode == 7 || list.typeCode == 10 || list.typeCode == 5 || list.typeCode == 8"></i>
                            </span>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number,
                default:1
            },
            item:{
                type:Object
            }
        },
        filters:{
            dateFilter:function(val){
                let data = new Date(val)
                let Month = parseInt(data.getMonth()) + 1
                return data.getFullYear() + '-' + Month + '-' + data.getDate()
            }
        },
        data(){
            return{
                widgetType:1,
                router:'resource_index',
                imgUrl:window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",//图片显示地址
                tabList:['热门','最新'],
                activeName:'热门',
                tableData:{
                    myCreateCesource:{
                        number:0
                    },
                    myCollection:{
                        number:0
                    },
                    downloadCount:{
                        number:0
                    },
                    myCredit:{
                        number:0
                    }
                }
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                 vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    let widgetUrl = stemp[0].apiUrl
                    vm.query(widgetUrl)
                }
            })
        },
        methods: {
            query(widgetUrl){
                let vm = this
                http.get(widgetUrl).then(function(xhr){
                    let objectA = xhr.data
                    vm.simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    var newObj = new Object();
                    vm.tableData = widgetFilter.showProps(objectA,'',vm.simpleMap,newObj)
                })
            },
            getTab(data){
                let vm = this
                this.activeName = data
            },
            nodeSplicing(){
                let irouter = widgetFilter.nodeSplicing(arguments[0],this.configList,this.simpleMap)
                if(irouter)
                this.$irouter(irouter)
            },
            collection(item){//收藏
                let vm = this
                http.get('/gateway/resource/common/operate/'+item.resourceId+'/1').then(function(xhr){
                    item.collection = 1
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .widget_cont{
        height: 280px;
        overflow: hidden;
    }
    .res_list:first-child{
        border-top: none;
    }
    .res_list{
        padding: 15px 0;
        border-top:1px dashed #E5E7EA;
        img{
            float: left;
            width: 20px;
            height: 20px;
        }
        .title{
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            font-weight: bold;
            margin-left: 28px;
            line-height: 16px;
            cursor: pointer;
        }
        .title:hover{
            color: #4183fc;
        }
        .list_about{
            margin-left: 28px;
            color: #999;
            font-size: 12px;
            margin-top: 5px;
            line-height: 16px;
            .user{
                color:#4183fc;
                margin-right:12px;
            }
            span{
                margin-right: 5px;
            }
            .list_bar{
                float: right;
                font-size: 16px;
                i{
                    margin-left:10px;
                    cursor:pointer;
                }
                i:hover{
                    color: #4183fc;
                }
            }
        }
    }
    .class_type{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin: 18px 0 0 0;
        .class_list{
            flex-grow: 1;
            margin: 0 10px;
            height: 66px;
            color:#fff;
            border-radius:5px;
            padding:10px 22px;
            box-sizing:border-box;
            /* line-height:17px; */
            text-align:center;
            font-size:12px;
            cursor:pointer;
            div:first-child{
                font-size: 24px;
                font-weight: bold;
            }
        }
        .class_list:first-child{
            margin-left: 0;
        }
        .class_list:last-child{
            margin-right: 0;
        }
        .class_list:nth-child(1){
            background:url(../img/widget/res1.png);
            background-size: 100% 100%;
        }
        .class_list:nth-child(2){
            background:url(../img/widget/res2.png);
            background-size: 100% 100%;
        }
        .class_list:nth-child(3){
            background:url(../img/widget/res3.png);
            background-size: 100% 100%;
        }
        .class_list:nth-child(4){
            background:url(../img/widget/res4.png);
            background-size: 100% 100%;
        }
    }
    .down_title{
        border-bottom: 1px solid #E5E7EA;
        line-height: 40px;
        margin-bottom: 10px;
        color: #666;
    }
    .down_main{
        display: flex;
        flex-wrap: wrap;
        .down_list{
            width: 50%;
            padding:5px 0;
            .ico{
                position: relative;
                color: #ccc;
                font-size: 22px;
                text-align: center;
                line-height: 22px;
                float: left;
                span{
                    position: absolute;top:0;right:0;left:0;bottom:0;
                    color:#fff;
                    font-size:12px;
                }
            }
            .title{
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                margin-left: 28px;
                cursor:pointer;
            }
            .title:hover{
                color: #4183fc;
            }
            .down_about{
                margin-left: 28px;
                color: #999;
                font-size: 12px;
                margin-top: 2px;
            }
        }
        .down_list:nth-child(2n+1){
            padding-right: 20px;
        }
        .down_list:nth-child(2n+2){
            padding-left: 20px;
        }
        .down_list:nth-child(1){
            .ico{
                color: #E63A00;
            }
        }
        .down_list:nth-child(2){
            .ico{
                color: #FF751B;
            }
        }
        .down_list:nth-child(3){
            .ico{
                color: #FFA21A;
            }
        }
    }
    .widget_level1,
    .widget_level3{
        .res_left{
            padding-top:15px;
        }
    }
    .widget_level3{
        .res_left{
            width: calc(~'33.33% - 45px');
        }
        .res_right{
            float: right;
            width: calc(~'66.66% - 25px');
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/resources.vue